// extracted by mini-css-extract-plugin
export default {"tsWrapper":"PolicyPages_tsWrapper__oL05l","para":"PolicyPages_para__XpHW+","listItem":"PolicyPages_listItem__ggRwN"};